import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Box } from "@mui/material";
import { StyledButton } from "../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../shared/components/form-builder/form-builder";
import {
  iBuyerSellerModel,
  mapJsonToBuyerSellerModel,
} from "../etc-models/Ibuyerseller-model";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useNotification from "../../../shared/hooks/useNotification";
import { useApi } from "../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../shared/components/loaders/page-loader";
import { ETCAppConfig } from "../../../shared/app-configs/etc-app-configs";
import { Utills } from "../../../shared/app-configs/utilit";
import { CustomButton } from "../../../shared/components/buttons/buttons";
import { INonCertifiedTrader } from "../../transaction-certificates/tc-models/tc-req-dto/tc-buyer-seller-details.req_dto";
import { useFormActions } from "../../../shared/hooks/form-builder.hooks";
import ModalPopup from "../../../shared/components/modals/custom-popup";
import NonCertifiedTraderInfo from "../../transaction-certificates/request-tc/tc-tabs/buyer-seller/non-certified-trader";

const SellerCertifiedProducts: React.FC = () => {
  const { notify } = useNotification();
  const { etcId, formtype } = useParams<string>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { loading, executeGet } = useApi();
  const [initialValues, setInitialValues] = useState(iBuyerSellerModel);
  const nonCertifiedTraderDatas: INonCertifiedTrader[] = [];

  const [stepData, setStepData] = useState({
    nonCertifiedTrader: nonCertifiedTraderDatas,
  });
  const { getCurrentFormValues, updateField } = useFormActions(
    "buyer-seller-details"
  );
  const navigate = useNavigate();
  const setZustandInitialState = (initial?: any) => {
    const defalutState: any = initialValues;
    //set zustand state inital values
    Object.entries(initial ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };
  useEffect(() => {
    const fetchTcBaseDetails = async () => {
      try {
        const response: any = await executeGet(
          ETCAppConfig.GET_ETC_BUYERSSELLERS_DETAILS,
          { etcId: etcId }
        );
        const data: any = mapJsonToBuyerSellerModel(response.data);
        if (data.nonCertifiedTrader.length > 0) {
          setStepData({ nonCertifiedTrader: data.nonCertifiedTrader })
        }
        setInitialValues(data);
        setZustandInitialState(data);
      } catch (err) {
        console.error("Failed to fetch TC Base Details:", err);
      }
    };
    fetchTcBaseDetails();
  }, []);

  // Simulate API call for fetching options
  //   const fetchTEDetallsFromAPI = async (
  //     value: string,
  //     offset: number,
  //     type: string,
  //     name?: string,
  //   ): Promise<any[]> => {
  //     try {
  //       const queryParams: Record<string, any> = {
  //         query_param: type == 'query' ? value : '',
  //         offset: offset,
  //         name: type == 'name' ? value : '',
  //       };
  //       // Fetch TE Details using the getTEDetails function
  //       const response = await buyerSellerDetailsService.getTEDetails(queryParams);
  //       const data = response.data
  //       Utills.cl(`fetchTEDetallsFromAPI details, query ${JSON.stringify(queryParams)} response data ${JSON.stringify(data)}`);

  //       return data
  //     } catch (error) {
  //       console.error('Error fetching TE details:', error);
  //       throw error; // Re-throw error to handle it in the calling code
  //     }
  //   };
  const handleDialogOpen = () => {
    setDialogOpen(true);
    const zustandData = getCurrentFormValues();
    const nonCertifiedTrader =
      zustandData?.nonCertifiedTrader?.length > 0
        ? zustandData?.nonCertifiedTrader
        : [];
    setStepData({ nonCertifiedTrader: nonCertifiedTrader });
  };
  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  // Handle selection change from SearchInput
  Utills.cl("initVal", JSON.stringify(initialValues));
  const formConfig: any = {
    pageName: "buyer-seller-details",
    initialValues,
    readOnly: true,
    validationSchema: null,
    sections: [
      {
        title: "Seller Details",
        fields: [
          {
            label: "Seller TE-ID",
            name: "sellerDetails.sellerTeId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Seller TE-ID",
              fullWidth: true,
            },
          },
          {
            label: "Legal name of Seller",
            name: "sellerDetails.sellerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller Address Line1",
            name: "sellerDetails.sellerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Seller Address 1",
              fullWidth: true,
            },
          },
          {
            label: "Seller Address Line2",
            name: "sellerDetails.sellerAddress2",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Seller Address 2",
              fullWidth: true,
            },
          },
          {
            label: "Seller Address Line3",
            name: "sellerDetails.sellerAddress3",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Seller Address 3",
              fullWidth: true,
            },
          },
          {
            label: "Town",
            name: "sellerDetails.sellerTown",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Postcode",
            name: "sellerDetails.sellerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          {
            label: "Country/Area",
            name: "sellerDetails.sellerCountryOrArea",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Country",
              fullWidth: true,
            },
          },
          {
            label: "State/Province",
            name: "sellerDetails.sellerStateOrProvince",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "State",
              fullWidth: true,
            },
          },
          {
            label: "Seller SC No.",
            name: "sellerDetails.sellerScNo",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select SC No.",
            },
          },
          {
            label: "",
            name: "nonCertifiedTrader",
            type: "component",
            gridSize: { xs: 2, md: 2, lg: 2 },
            required: true,
            children: (
              <>
                {" "}
                <CustomButton
                  sx={{
                    marginTop: "22px",
                    borderRadius: "30px", // Doubles the default border radius
                    padding: "1 3", // Adds padding for a balanced look
                    marginRight: 2, // Spacing between buttons
                    textTransform: "none", // Keeps button text in sentence case
                    backgroundColor: "#F0CD7F",
                    color: "#1C1C1C",
                    fontWeight: "400",
                    "&:hover": {
                      backgroundColor: "#E0B86F", // Change background color on hover
                      color: "#000000", // Change text color on hover
                      // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                  onClick={handleDialogOpen}
                  variant="contained"
                  placement="center"
                  size="small"
                  errorMessage=""
                  label={"View Non-Certified Trader Info"}
                ></CustomButton>
                <span
                  style={{
                    fontSize: "0.8em",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {stepData?.nonCertifiedTrader.length}
                  Records Added
                </span>
              </>
            ),
            props: {},
          },
          {
            label: "Seller License No.",
            name: "sellerDetails.sellerLicenseNo",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Seller License No.",
              fullWidth: true,
            },
          },
          {
            label: "Legal name of non-certified trader",
            name: "sellerDetails.sellerNonCertifiedTraderName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Trader Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller non-certified trader TE-ID",
            name: "sellerDetails.sellerNonCertifiedTraderTEId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter TE-ID",
              fullWidth: true,
            },
          },
          {
            label: "Selling on Behalf of Certified Organization",
            name: "sellerDetails.sellingOnBehalfOfFlag",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              options: [
                { value: "Y", label: "Yes" },
                { value: "N", label: "No" },
              ],
            },
          },
          {
            label: "Seller Certified Organization Name",
            name: "sellerDetails.sellerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Certified Organization Name",
              fullWidth: true,
            },
          },
          {
            label: "Sender Role",
            name: "sellerDetails.senderRole",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Role",
              fullWidth: true,
            },
          },
        ],
      },
      {
        title: "Buyer Details",
        fields: [
          {
            label: "Buyer License No.",
            name: "buyerDetails.buyerLicenseNo",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter license number",
              fullWidth: true,
            },
          },
          // {
          //   label: "Does the Buyer have a TE-ID?",
          //   name: "buyerDetails.isBuyerTeCertified",
          //   type: "radio",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   // disabled: true,
          //   props: {
          //     options: [
          //       { value: "Y", label: "Yes" },
          //       { value: "N", label: "No" },
          //     ],
          //   }
          // },
          {
            label: "Buyer TE-ID",
            name: "buyerDetails.buyingOnBehalfOfFlag",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Buyer TE-ID",
              fullWidth: true,
            },
          },
          {
            label: "Legal Name of Buyer",
            name: "buyerDetails.buyerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Search Buyer Name",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Address 1",
            name: "buyerDetails.buyerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Buyer Address 1",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Address 2",
            name: "buyerDetails.buyerAddress2",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Buyer Address 2",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Address 3",
            name: "buyerDetails.buyerAddress3",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Buyer Address 3",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Town",
            name: "buyerDetails.buyerTown",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Postcode",
            name: "buyerDetails.buyerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Country/Area",
            name: "buyerDetails.buyerCountryOrArea",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Buyer Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Buyer State/Province",
            name: "buyerDetails.buyerStateOrProvince",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Enter Buyer State/Province",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Certified Organization Name",
            name: "buyerDetails.buyerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Select Buyer Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Receiver Role",
            name: "buyerDetails.receiverRole",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            // disabled: true,
            props: {
              placeholder: "Role",
              fullWidth: true,
            },
          },
        ],
      },
    ],
    handleSubmit: async (values: any) => {},
  };

  // Ref to access the Formik instance in FormBuilder
  const formRef = useRef<any>(null);

  // Handle form submission outside of FormBuilder
  const handleSubmit = () => {
    navigate(`/etc/${formtype}/shipments-details/${etcId}`);
  };
  const handleCancel = () => {
    //ToDo Need to close the Tab
  };
  return (
    <Box>
      {/* Render the FormBuilder component and pass formRef and onSubmit handler */}
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <FormBuilder
            formConfig={formConfig}
            onSubmit={formConfig.handleSubmit}
            formRef={formRef}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <StyledButton variant="contained" onClick={handleSubmit}>
              Next
            </StyledButton>
            <NavLink to="/tc-dashboard">
              <StyledButton variant="contained">Cancel</StyledButton>
            </NavLink>
          </Box>
        </>
      )}
      <ModalPopup
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
      >
        <NonCertifiedTraderInfo
          nonCertifiedInfoData={stepData.nonCertifiedTrader}
          setNonCertifiedInfoData={(data) =>
            handleDataUpdate("nonCertifiedTrader", data)
          }
        />
      </ModalPopup>
    </Box>
  );
};

export default SellerCertifiedProducts;
